import Isotope from "isotope-layout";
// prettier ignore
import packery from "isotope-packery";
import InfiniteScroll from "infinite-scroll";
import imagesLoaded from "imagesloaded";
import { enhance } from "@grrr/hansel";

InfiniteScroll.imagesLoaded = imagesLoaded;

const fontsLoaded = function (el) {
    document.fonts.ready.then(() => {
        window.isoT.layout();
        console.log("Fonts ready");
    });
};

const applyMasonry = function (el) {
    console.log("apply masonry on ", el);

    window.isoT = new Isotope(el, {
        itemSelector: ".packery-item",
        layoutMode: "packery",
        percentPosition: true,
        transitionDuration: 300,
        stagger: 20,
        scrollThreshold: 500,

        packery: {
            gutter: ".gutter-sizer",
        },
        hiddenStyle: {
            opacity: 0,
            transform: "translate(0,100px)",
        },
        visibleStyle: {
            opacity: 1,
            transform: "translate(0,0px)",
        },
    });

    const infScroll = new InfiniteScroll(el, {
        path: ".next",
        append: ".packery-item",
        scrollThreshold: 1000,
        prefill: true,
        outlayer: window.isoT,
        hideNav: ".articles__pagination",
        status: ".articles__status",
        onInit() {
            console.log("Inf scroll inited");
            setTimeout(function () {
                const e = document.createEvent("Event");
                e.initEvent("scroll", true, true);
                window.dispatchEvent(e);
            }, 1000);
        },
    });
    infScroll.on("request", function (body, path, items, response) {
        const loading = document.querySelectorAll(".articles__loading-new");
        for (let x = 1; x <= 8; x += 1) {
            loading[loading.length - 1].classList.remove(
                `apply-font-accent--${x}`
            );
        }
        loading[loading.length - 1].classList.add(
            "articles__loading-new--show"
        );
        loading[loading.length - 1].classList.add(
            `apply-font-accent--${Math.ceil(Math.random() * 8)}`
        );
        if (window.isoT) {
            window.isoT.layout();
        }
    });
    infScroll.on("append", function (body, path, items, response) {

        enhance(items[items.length - 1], window.mmEnhancers);
        const loading = document.querySelectorAll(".articles__loading-new");

        loading[loading.length - 1].classList.remove(
            "articles__loading-new--show"
        );
    });
};

export const masonry = function (el) {
    applyMasonry(el);

    fontsLoaded();
};

export const masonrySF = function (el) {
    console.log("jQuery", jQuery);

    applyMasonry(el);

    fontsLoaded();
};

export const filtersOnChange = function (el) {
    console.log("filtersOnChange init");
    console.log(jQuery(document));
    jQuery(document).on(
        "sf:ajaxfinish",
        ".searchandfilter",
        function (a, b, c) {
            console.log(b);
            resetFilters(b.object.$fields);
            applyMasonry(
                document
                    .querySelector(b.targetSelector)
                    .querySelector(".articles__container")
            );
        }
    );
};

const resetFilters = function (fields) {
    const container = document.querySelector(".active-filters__container");
    if (container.firstChild) {
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
    }
    console.log(fields);
    let added = 0;
    [...fields].forEach(function (field) {
        const filter = document.createElement("div");
        filter.classList.add("active-filters__filter");
        filter.setAttribute("data-name", field.dataset.sfFieldName);
        const index = field.querySelector("select").selectedIndex;
        filter.innerText = field
            .querySelector("select")
            .options[index].text.replace(/\([0-9,]+\)/, "")
            .trim();
        filter.addEventListener("click", function () {
            const name = this.getAttribute("data-name");
            document.querySelector(
                `.searchandfilter [data-sf-field-name="${name}"] select`
            ).selectedIndex = 0;
            jQuery(`[data-sf-field-name="${name}"] select`).trigger("change");
            this.remove();
        });
        if (index != 0) {
            container.appendChild(filter);
            added++;
        }
    });

    if (added > 0) {
        document
            .querySelector(".active-filters__label")
            .classList.remove("active-filters__label--hide");
    } else {
        document
            .querySelector(".active-filters__label")
            .classList.add("active-filters__label--hide");
    }
};
